import { ExternalDomainModelChangedEventArgsInterface, ModelInterface } from '@nts/std/interfaces';

export class ExternalDomainModelChangedEventArgs<
    TModel extends ModelInterface = ModelInterface
> implements ExternalDomainModelChangedEventArgsInterface<TModel> {
    senderName: string;
    domainModel: TModel;
}
